<div class="side-nav-panel-content termial-runs">

  <app-loading-screen *ngIf="loading"></app-loading-screen>

  <div class="panel-container">
    <div *ngFor="let terminalRun of terminalRunTasks" class="form-container">
      <button mat-button (click)="panel.toggle()" class="toggle-button">
        <mat-icon [ngClass]="{'is-open': panel.expanded}">navigate_next</mat-icon>
      </button>
      <mat-expansion-panel hideToggle #panel class="expansion-panel">
        <mat-expansion-panel-header>
          <mat-panel-description>
            <div class="header">
              <div class="title">
                <mat-label>Terminal Run:</mat-label>
              </div>
              <app-time-picker [dateTimeString]="terminalRun.plannedEnd" (click)="$event.stopPropagation()"
                (result)="updateTaskDateTime(terminalRun, $event)" [minDate]="minFilterDate">
              </app-time-picker>
            </div>
          </mat-panel-description>
        </mat-expansion-panel-header>
        <app-terminal-run-details [task]="terminalRun" (updateTask)="refreshData()"></app-terminal-run-details>
      </mat-expansion-panel>
    </div>
  </div>

  <div class="add-button">
    <button mat-raised-button color="primary" (click)="addNewTerminalTask()">
      <mat-icon>control_point</mat-icon>
    </button>
  </div>

</div>